<template>
  <transition name="modal-fade">
    <div class="modal fade show child-modal"
         style="display: block; padding-right: 15px;">
      <div class="modal-dialog modal-lg modal-centered">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="header">
              <h4 id="exampleModalLabel"
                  class="modal-title">
                Modal title
              </h4>
            </slot>
            <a aria-label="Close"
               class="close"
               data-dismiss="modal"
               type="button"
               @click="close"><i class="fa fa-times"/></a>
          </div>
          <div class="modal-body">
            <slot name="body">
              <h5>
                Body should be here!
              </h5>
            </slot>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary"
                    data-dismiss="modal"
                    type="button"
                    @click="close"> Close</button>
            <slot name="footer"/>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
	name: 't-modal',
	mounted () {
		document.body.classList.add('modal-open')
	},
	destroyed () {
		document.body.classList.remove('modal-open')
	},
	methods: {
		close () {
			this.$emit('close')
		}
	}
}
</script>

<style>
  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }
</style>



// WEBPACK FOOTER //
// src/components/common/childModal/index.vue